import React from 'react';
import { Nav, NavItem, NavLink } from 'react-bootstrap';
import { Images, Grid, Gear, Sliders } from 'react-bootstrap-icons';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine if a menu item should be considered active
  const isActive = (path: string) => {
    if (path === '/') {
      // Home is active for root path or any folder paths
      return location.pathname === '/' || location.pathname.startsWith('/folder');
    }
    if (path.startsWith('/settings')) return location.pathname.startsWith('/settings');
    return location.pathname === path;
  };

  const menuItems = [
    {
      title: 'Content',
      icon: <Grid size={20} />,
      path: '/',
    },
    {
      title: 'Media',
      icon: <Images size={20} />,
      path: '/media',
    },
    {
      title: 'Settings',
      icon: <Sliders size={20} />,
      path: '/settings/integrations',
    },
  ];

  return (
    <div className="sm-sidebar">
      {/* Decorative gear in background */}
      <div className="sm-sidebar__gear">
        <Gear size={200} className="sm-animate-gear" />
      </div>
      
      <Nav className="sm-sidebar__nav flex-column">
        <div className="mb-4">
          <h5 className="sm-sidebar__heading">⚙ Navigation</h5>
        </div>
        {menuItems.map((item) => (
          <NavItem key={item.path} className="sm-sidebar__item">
            <NavLink
              className={`sm-sidebar__link ${isActive(item.path) ? 'sm-sidebar__link--active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <span className="sm-sidebar__link-icon">{item.icon}</span>
              <span className="sm-sidebar__link-text">{item.title}</span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      {/* Bottom decorative border */}
      <div className="sm-sidebar__bottom-line" />
    </div>
  );
};

export default Sidebar;
